import * as v from 'valibot';
import {
    fieldModelErrors as fErr,
    txtIsRequired,
    txtNoEmpty
} from '~/constants';
import {
    VisibilityRole
} from '~/types';
import type {
    BundleSaveConfig
} from '~/types';
import { BaseModel } from '~/models/base-model';


export const BundleSaveConfigModel = v.object({
    name: v.pipe(
        v.string(fErr.name),
        v.minLength(1, `Name ${txtNoEmpty}`),
        v.maxLength(50, `Name cannot exceed 50 characters`)
    ),
    visibility: v.enum(VisibilityRole, `Sharing role ${txtIsRequired}`)
});

export class BundleSaveConfigLegacyModel extends BaseModel<BundleSaveConfig> {
    name = null;
    visibility = null;
}
